import {
  LayoutDashboard, Users, Building2, Briefcase, ListTodo, FileSpreadsheet,
  Receipt, Wallet, Boxes, UserCog, CalendarCheck, BarChart3, Settings,
  Calculator, Landmark, ScrollText, BookOpen, Scale, PiggyBank, TrendingUp,
  Percent, ClipboardList, FileText, Coins, Home, ShieldCheck, Package, ShoppingCart,
} from "lucide-react";

// Enterprise nav tree — Finance rolls up BOQ, Invoices, Expenses, Accounting, Reports.
// Each item carries a `moduleKey` matching backend RBAC modules so the sidebar
// can hide entries the current user has no `view` permission for.
export const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, moduleKey: "dashboard" },
  { to: "/leads", label: "CRM & Leads", icon: Users, moduleKey: "crm" },
  { to: "/clients", label: "Clients", icon: Building2, moduleKey: "clients" },
  { to: "/projects", label: "Projects", icon: Briefcase, moduleKey: "projects" },
  { to: "/tasks", label: "Tasks", icon: ListTodo, moduleKey: "tasks" },
  {
    key: "finance", label: "Finance", icon: Calculator, moduleKey: "finance",
    children: [
      { to: "/accounting?tab=dashboard", label: "Dashboard", icon: LayoutDashboard, match: ["/accounting"], moduleKey: "finance" },
      {
        key: "finance-boq", label: "BOQ & Estimation", icon: FileSpreadsheet, moduleKey: "boq",
        children: [
          { to: "/boq", label: "BOQ", icon: FileSpreadsheet, moduleKey: "boq" },
          { to: "/boq?view=estimates", label: "Estimates", icon: ScrollText, match: ["/boq"], moduleKey: "boq" },
          { to: "/boq?view=cost-analysis", label: "Cost Analysis", icon: TrendingUp, match: ["/boq"], moduleKey: "boq" },
          { to: "/boq?view=budget", label: "Budget Planning", icon: PiggyBank, match: ["/boq"], moduleKey: "boq" },
        ],
      },
      {
        key: "finance-invoices", label: "Invoices", icon: Receipt, moduleKey: "invoices",
        children: [
          { to: "/invoices", label: "Customer Invoices", icon: Receipt, moduleKey: "invoices" },
          { to: "/invoices?type=purchase", label: "Purchase Bills", icon: ScrollText, match: ["/invoices"], moduleKey: "invoices" },
          { to: "/invoices?type=credit", label: "Credit Notes", icon: FileText, match: ["/invoices"], moduleKey: "invoices" },
          { to: "/invoices?type=debit", label: "Debit Notes", icon: FileText, match: ["/invoices"], moduleKey: "invoices" },
          { to: "/invoices?type=recurring", label: "Recurring Invoices", icon: ClipboardList, match: ["/invoices"], moduleKey: "invoices" },
        ],
      },
      {
        key: "finance-expenses", label: "Expenses", icon: Wallet, moduleKey: "expenses",
        children: [
          { to: "/expenses?category=Site", label: "Site Expenses", icon: Building2, match: ["/expenses"], moduleKey: "expenses" },
          { to: "/expenses?category=Office", label: "Office Expenses", icon: Home, match: ["/expenses"], moduleKey: "expenses" },
          { to: "/expenses?category=Labour", label: "Labour Expenses", icon: UserCog, match: ["/expenses"], moduleKey: "expenses" },
          { to: "/expenses?category=Materials", label: "Material Expenses", icon: Boxes, match: ["/expenses"], moduleKey: "expenses" },
          { to: "/expenses?category=Equipment", label: "Equipment Expenses", icon: Boxes, match: ["/expenses"], moduleKey: "expenses" },
          { to: "/expenses?view=categories", label: "Expense Categories", icon: ClipboardList, match: ["/expenses"], moduleKey: "expenses" },
        ],
      },
      {
        key: "finance-accounting", label: "Accounting", icon: BookOpen, moduleKey: "finance",
        children: [
          { to: "/accounting?tab=dashboard", label: "Dashboard", icon: LayoutDashboard, match: ["/accounting"], moduleKey: "finance" },
          { to: "/accounting?tab=coa", label: "Chart of Accounts", icon: Scale, match: ["/accounting"], moduleKey: "finance" },
          { to: "/accounting?tab=journals", label: "Journal Entries", icon: ClipboardList, match: ["/accounting"], moduleKey: "finance" },
          { to: "/accounting?tab=reports&r=gl", label: "General Ledger", icon: FileText, match: ["/accounting"], moduleKey: "finance" },
          { to: "/accounting?tab=reports&r=ar", label: "Accounts Receivable", icon: TrendingUp, match: ["/accounting"], moduleKey: "finance" },
          { to: "/accounting?tab=reports&r=ap", label: "Accounts Payable", icon: TrendingUp, match: ["/accounting"], moduleKey: "finance" },
          { to: "/accounting?tab=banking", label: "Banking", icon: Landmark, match: ["/accounting"], moduleKey: "finance" },
          { to: "/accounting?tab=reports&r=cf", label: "Cash Flow", icon: Coins, match: ["/accounting"], moduleKey: "finance" },
          { to: "/accounting?tab=gst", label: "GST & Taxes", icon: Percent, match: ["/accounting"], moduleKey: "finance" },
          { to: "/accounting?tab=reports", label: "Financial Reports", icon: FileText, match: ["/accounting"], moduleKey: "finance" },
          { to: "/accounting?tab=fy-settings", label: "Financial Year Settings", icon: Settings, match: ["/accounting"], moduleKey: "finance" },
        ],
      },
      {
        key: "finance-reports", label: "Reports", icon: BarChart3, moduleKey: "reports",
        children: [
          { to: "/accounting?tab=reports&r=pnl", label: "Profit & Loss", icon: TrendingUp, match: ["/accounting"], moduleKey: "reports" },
          { to: "/accounting?tab=reports&r=bs", label: "Balance Sheet", icon: Scale, match: ["/accounting"], moduleKey: "reports" },
          { to: "/accounting?tab=reports&r=tb", label: "Trial Balance", icon: FileText, match: ["/accounting"], moduleKey: "reports" },
          { to: "/accounting?tab=reports&r=cf", label: "Cash Flow", icon: Coins, match: ["/accounting"], moduleKey: "reports" },
          { to: "/reports?type=expense", label: "Expense Reports", icon: Wallet, match: ["/reports"], moduleKey: "reports" },
          { to: "/reports?type=invoice", label: "Invoice Reports", icon: Receipt, match: ["/reports"], moduleKey: "reports" },
          { to: "/reports?type=boq", label: "BOQ Reports", icon: FileSpreadsheet, match: ["/reports"], moduleKey: "reports" },
          { to: "/reports?type=project", label: "Project Financial Reports", icon: Briefcase, match: ["/reports"], moduleKey: "reports" },
        ],
      },
    ],
  },
  { to: "/inventory", label: "Inventory", icon: Boxes, moduleKey: "inventory" },
  { to: "/material-library", label: "Material Library", icon: Package, moduleKey: "library" },
  { to: "/purchase-orders", label: "Purchase Orders", icon: ShoppingCart, moduleKey: "inventory" },
  { to: "/employees", label: "Employees", icon: UserCog, moduleKey: "employees" },
  { to: "/hr", label: "HR Management", icon: UserCog, moduleKey: "employees" },
  { to: "/attendance", label: "Attendance", icon: CalendarCheck, moduleKey: "attendance" },
  { to: "/reports", label: "Analytics & Reports", icon: BarChart3, moduleKey: "reports" },
  { to: "/library", label: "Library", icon: Boxes, moduleKey: "library" },
  { to: "/portal", label: "Client Portal", icon: Home, moduleKey: "portal", clientOnly: true },
  { to: "/users", label: "User Management", icon: ShieldCheck, moduleKey: "users" },
  { to: "/settings", label: "Settings", icon: Settings, moduleKey: "settings" },
];
